<template>
  <v-container class="pb-6" fluid>
    <v-row>
      <v-col class="d-flex justify-center">
        <v-btn
          v-for="platform in socialMedia"
          :color="color"
          :href="platform.url"
          :key="platform.type"
          target="_blank"
          :size="rewardsFormat ? 'x-large' : 'small'"
          icon
          :class="{ 'px-7': rewardsFormat }"
          ><v-icon :size="rewardsFormat ? 40 : 25"
            >mdi-{{ platform.type }}
          </v-icon></v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "SocialMedia",
  computed: {
    ...mapGetters("store", { rewardsFormat: "rewardsFormat" }),
    ...mapState({
      socialMedia: (state) =>
        state.store.info.store_info.social_media?.filter(
          (platform) => platform.url,
        ),
    }),
  },
  props: { color: String },
};
</script>
